import { render, staticRenderFns } from "./GroupEditDialog.vue?vue&type=template&id=0c3b4526&scoped=true&"
import script from "./GroupEditDialog.vue?vue&type=script&lang=js&"
export * from "./GroupEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./GroupEditDialog.vue?vue&type=style&index=0&id=0c3b4526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3b4526",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VBtn,VCol,VDialog,VImg,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2687757686/src/ueyes-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c3b4526')) {
      api.createRecord('0c3b4526', component.options)
    } else {
      api.reload('0c3b4526', component.options)
    }
    module.hot.accept("./GroupEditDialog.vue?vue&type=template&id=0c3b4526&scoped=true&", function () {
      api.rerender('0c3b4526', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/GroupEditDialog.vue"
export default component.exports